import * as React from 'react'
import ScrollAnimation from 'react-animate-on-scroll'
import './FullSizeSection.scss'
import YoutubeBackground from 'react-youtube-background'
import PropTypes from 'prop-types'
import MediaItem from './MediaItem'
import styled from '../../utils/styled'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import {  MobileView, isBrowser } from "react-device-detect";
interface FullSizeSectionProps {
  title: string
  subtitle: string
  backgroundImage: string
  className: string
  media: any
}

const FullsizeSection: React.FunctionComponent<FullSizeSectionProps> = ({
  children,
  title,
  subtitle,
  backgroundImage,
  className = '',
  media
}) => {
   const [loaded, setLoaded] = React.useState(false);
  function ready(event:any) {
    setLoaded(true);
  }
  return (
  <FullSection className={(className === '' ? '' : className) + ' content parallax'}>
    <div className="container-fluid no-padding">
      <div className="jumbotron jumbotron-fluid">
        {isBrowser && media != undefined && media.hasOwnProperty('url') && media['type'] === 'youtube' && (
          <YoutubeBackground
            videoId={
              media.url.indexOf('/') != -1
                ? media.url.split('/')[media.url.split('/').length - 1]
                : media.url
            } // default -> "jssO8-5qmag"
            // aspectRatio={media.ratio} // default -> "16:9"
            // overlay={media.overlay} // defaults -> null | e.g. "rgba(0,0,0,.4)"
            className={'youtubeplayer'} // defaults -> null
            onReady={ready}       // defaults -> null
          >
            {/* YOUR CONTENT */}
          </YoutubeBackground>
        )}

{!isBrowser && media != undefined && media.hasOwnProperty('url') && media['type'] === 'youtube' && (
  <Image style={{
            backgroundImage:
              media.hasOwnProperty('url') ?
              'url(\'https://img.youtube.com/vi/' + (media.url.indexOf('/') != -1  ? media.url.split('/')[media.url.split('/').length - 1] : media.url)+'/maxresdefault.jpg\')' :
              'none'
            }}
            alt="cover"
             >
               {(media.hasOwnProperty('url')) && (<ImageHidden onLoad={ready} src={'https://img.youtube.com/vi/' + (media.url.indexOf('/') != -1  ? media.url.split('/')[media.url.split('/').length - 1] : media.url)+'/maxresdefault.jpg'} />) }
             </Image>


        )}
        <div className={loaded ? 'gradient loaded' : 'gradient'}></div>

        <div className="container">
          <ScrollAnimation animateIn="slideInUp" animateOnce={true} initiallyVisible={true}>
            <ScrollAnimation
              className="side-description"
              animateIn="headerLineIn"
              animateOnce={true}
            >
              <ScrollAnimation animateIn="fadeIn" animateOut="fadeOut" animateOnce={true}>
                <h1>{title}</h1>
              </ScrollAnimation>
              <ScrollAnimation animateIn="fadeIn" animateOut="fadeOut" animateOnce={true} delay={1}>
                <h2>{subtitle}</h2>
              </ScrollAnimation>
              <span>{children}</span>
            </ScrollAnimation>
          </ScrollAnimation>
        </div>
        <ScrollAnimation
          duration={2}
          className={loaded ? 'image-zoom fadein' : 'image-zoom fadeout'}
          animateIn="zoomBack"
          animateOnce={true}
          style={{
            backgroundImage:
                (backgroundImage === undefined ? 'none' : 'url('+backgroundImage+ ') ') ,
            opacity: 1
          }}
        >
          {(backgroundImage != undefined) && (<ImageHidden onLoad={ready} src={backgroundImage} />) }
        </ScrollAnimation>
        {/* {media != undefined && media.hasOwnProperty('url') && media['type'] != 'image' && (
          <MediaItem type={media.type} url={media.url} />
        )} */}
      </div>
    </div>
  </FullSection>
)}

export default FullsizeSection

const FullSection = styled('div')`
  @media (max-width: ${props => props.theme.breakpoints.lg}) {
    .jumbotron {
      overflow: visible;
      height: auto;
      min-height: 100vh;
      .container {
        .side-description {
          h1,
          h2 {
            font-size: 3rem;
          }
          span {
            width: 100%;
          }
        }
      }
    }
  }
`

const Image = styled('div')`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  position:absolute;
`
const ImageHidden = styled('img')`
  display: none;
`
